import {ServicehomePage} from './servicehome/servicehome';
import {ServiceeditPage} from './serviceedit/serviceedit';

export const SERVICE_INDEX = [
    ServicehomePage,
    ServiceeditPage
];


// WEBPACK FOOTER //
// ./src/pages/service/index.ts